import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router";

// layouts
import { MainLayout } from "layouts";

// components
import { Button } from "components/common";
import { TextInput } from "components/form";

import { updateUserInfo } from "redux/slices/user/userSlice";

const EditName = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);

  const initialValues = {
    name: userInfo.name || "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("이름을 입력해주세요"),
  });

  const handleClickEditButton = (values) => {
    dispatch(
      updateUserInfo({
        seqManagerMobile: userInfo.seqManagerMobile,
        name: values.name,
      }),
    )
      .unwrap()
      .then((result) => {
        if (result) {
          navigate(-1);
        }
      })
      .catch((e) => {});
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "이름 변경" }}
    >
      <Wrapper>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => handleClickEditButton(values)}
        >
          {({ values, errors, handleChange }) => (
            <Form>
              <TextInput
                name="name"
                label="이름"
                maxLength={30}
                placeholder="이름을 입력해주세요"
                onChange={(e) => {
                  e.target.value = e.target.value.trim();
                  handleChange(e);
                }}
              />

              <BottomButtonWrapper>
                <Button
                  variant="contained"
                  className="square"
                  padding="16px"
                  text="이름 변경"
                  disabled={values.name === userInfo.name || errors.name}
                  type="submit"
                />
              </BottomButtonWrapper>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 20px 0px 20px;
`;

const BottomButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 40px;
`;

export default EditName;
